module.exports = __webpack_public_path__ + "img/login_logo_uat.b7dd5e85.png";